import { renderRichText } from "@storyblok/react"
import { Button } from "../ui/button"
import { useAuthModal } from "../auth/use-auth-modal"

export default function BlogPost({ blok }: any) {
  const { showRegister } = useAuthModal()

  return (
    <article className="max-w-4xl mx-auto px-6 py-24 text-gray-900">
      {/* Title + Date */}
      <header className="mb-12 text-center">
        <div
          className="text-4xl md:text-5xl font-extrabold leading-tight tracking-tight"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.title) || "",
          }}
        />
        <div
          className="text-lg text-gray-500 mt-4 tracking-wide"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.date) || "",
          }}
        />

        <div className="w-16 h-1 bg-blurple/60 rounded-full mx-auto mt-6" />
      </header>

      {/* Feature Image */}
      {blok.featureImage && (
        <div className="mb-16 rounded-3xl overflow-hidden shadow-md border border-gray-100">
          <img
            src={blok.featureImage.filename}
            alt={blok.featureImage.alt || "Blog image"}
            className="w-full h-auto object-contain"
          />
        </div>
      )}

      {/* Body */}
      <section
        className="prose prose-lg md:prose-xl prose-h2:text-3xl prose-h3:text-2xl prose-p:leading-relaxed prose-p:text-gray-800 prose-strong:font-semibold prose-a:text-blurple hover:prose-a:underline prose-img:rounded-xl"
        dangerouslySetInnerHTML={{
          __html: renderRichText(blok.body) || "",
        }}
      />

      {/* CTA */}
      <div className="flex justify-center mt-20">
        <Button
          onClick={() => showRegister({ accountType: "coach" })}
          size="lg"
          className="px-8 py-3 text-base rounded-xl shadow-sm hover:shadow-md transition"
        >
          Start Now
        </Button>
      </div>

      {/* Tags */}
      {Array.isArray(blok.tags) && blok.tags.length > 0 && (
        <div className="flex flex-wrap justify-center gap-3 mt-16">
          {blok.tags.map((tag: string, index: number) => (
            <span
              key={index}
              className="px-4 py-1 rounded-full text-sm font-medium bg-blurple/10 text-blurple border border-blurple/20"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
    </article>
  )
}
